export * from './area-setup-parameters-list.component';
export * from './area-setup-parameters-add-edit.component';